<template>
<div class="gbpro-page">
  <HeadNav selectedLanguage="en" :page="pageKey" />

  <main class="gbpro-main">
    <section :class="['gbpro-hero', `gbpro-hero--${page.hero.variant || 'home'}`, `gbpro-hero--page-${pageKey}`, { 'gbpro-hero--centered': page.hero.centered, 'gbpro-hero--compact': page.hero.compact }]">
      <div class="gbpro-hero__inner">
        <div class="gbpro-hero__copy">
          <template v-if="pageKey === 'download'">
            <div class="gbpro-download-hero-mark">
              <img :src="downloadHeroIcon" alt="GB WhatsApp Pro app icon">
            </div>
            <h1 class="gbpro-download-hero-title">
              <span>Download GB WhatsApp Pro APK</span>
            </h1>
            <p class="gbpro-hero-line">Latest version {{ apkMeta.version }} &bull; {{ apkMeta.size }} &bull; {{ apkMeta.android }} &bull; Easy installation APK.</p>
            <div class="gbpro-actions">
              <button class="gbpro-btn gbpro-btn--primary" @click="downloadApk">
                <GbproHeroIcon name="download" tone="glass" />
                Download APK ({{ apkMeta.version }})
              </button>
            </div>
          </template>
          <template v-else>
          <p v-if="page.hero.eyebrow" class="gbpro-eyebrow">
            <GbproHeroIcon name="download" tone="solid" />
{{ page.hero.eyebrow }}
</p>
          <h1>
            <template v-if="page.hero.titleLines">
              <span
                v-for="(line, lineIndex) in page.hero.titleLines"
                :key="`${line.text}-${lineIndex}`"
                :class="['gbpro-hero-title-line', line.tone ? `gbpro-hero-title-line--${line.tone}` : '']">
{{ line.text }}<span v-if="line.accent" class="gbpro-hero-title-accent">{{ line.accent }}</span>
</span>
            </template>
            <template v-else-if="page.hero.titleAccent">
{{ heroTitlePrefix(page.hero) }} <span>{{ page.hero.titleAccent }}</span>
</template>
            <template v-else-if="heroTitleSuffix(page.hero)">
              <span class="gbpro-hero-heading">
                {{ heroTitleMain(page.hero) }}<span class="gbpro-hero-heading__suffix">{{ heroTitleSuffix(page.hero) }}</span>
              </span>
            </template>
            <template v-else>
{{ page.hero.title }}
</template>
          </h1>
          <p v-for="(line, lineIndex) in page.hero.lines" :key="`hero-line-${lineIndex}`" class="gbpro-hero-line">
            <GbproRichText :text="line" />
          </p>
          <div v-if="page.hero.badges" class="gbpro-badges">
            <span v-for="badge in page.hero.badges" :key="badge">
              <GbproHeroIcon name="check" tone="soft" />
              {{ badge }}
            </span>
          </div>
          <div v-if="page.hero.primary || page.hero.secondary" class="gbpro-actions">
            <button v-if="page.hero.primary" class="gbpro-btn gbpro-btn--primary" @click="downloadApk">
              <GbproHeroIcon name="download" tone="glass" />
              {{ page.hero.primary }}
            </button>
            <a v-if="page.hero.secondary" class="gbpro-btn gbpro-btn--secondary" :href="`#${page.hero.secondaryAnchor}`">
              <GbproHeroIcon name="guide" tone="muted" />
              {{ page.hero.secondary }}
            </a>
          </div>
          </template>
        </div>

        <div v-if="page.hero.sidePanel && pageKey !== 'download'" class="gbpro-hero-side">
          <div class="gbpro-hero-side__mark">
            <GbproHeroIcon name="download" tone="solid" />
            <span>{{ page.hero.sidePanel.label }}</span>
          </div>
          <strong>{{ page.hero.sidePanel.title }}</strong>
          <p>{{ page.hero.sidePanel.text }}</p>
          <div class="gbpro-hero-side__steps">
            <span v-for="(item, itemIndex) in page.hero.sidePanel.items" :key="item.label">
              <b class="gbpro-hero-side__step-index">{{ itemIndex + 1 }}</b>
              {{ item.label }}
            </span>
          </div>
        </div>

        <div v-if="page.hero.image" class="gbpro-hero__art">
          <img v-if="page.hero.image" :src="page.hero.image" :alt="page.hero.imageAlt || page.hero.title" class="gbpro-hero-icon">
        </div>

        <div v-if="page.hero.card" class="gbpro-download-card">
          <div v-for="item in page.hero.card" :key="item.label" class="gbpro-download-card__row">
            <span>
              <GbproHeroIcon :name="item.icon || 'version'" tone="soft" />
              {{ item.label }}
            </span>
            <strong>{{ item.value }}</strong>
          </div>
          <button class="gbpro-btn gbpro-btn--primary" @click="downloadApk">
            <GbproHeroIcon name="download" tone="glass" />
            Download APK
</button>
        </div>
      </div>
      <div v-if="page.hero.preview" class="gbpro-hero-preview" aria-hidden="true">
        <div class="gbpro-preview-window">
          <div class="gbpro-preview-window__bar">
            <span />
            <span />
            <span />
          </div>
          <div class="gbpro-preview-window__body">
            <div class="gbpro-preview-panel gbpro-preview-panel--primary">
              <strong>v18.80</strong>
              <span>Latest APK</span>
            </div>
            <div class="gbpro-preview-panel">
              <strong>Privacy</strong>
              <span>Hide status and ticks</span>
            </div>
            <div class="gbpro-preview-panel">
              <strong>Themes</strong>
              <span>Flexible interface controls</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <article :class="['gbpro-content', { 'gbpro-content--legal': isLegal, [`gbpro-content--${pageKey}`]: !isLegal }]">
      <section
        v-for="(section, index) in page.sections"
        :id="sectionId(section, index)"
        :key="`${section.title || 'section'}-${index}`"
        :class="sectionClass(section)">
        <h2 v-if="section.title">
          <template v-if="section.titleAccent">
{{ section.title }} <span class="gbpro-section-title-accent">{{ section.titleAccent }}</span>
</template>
          <template v-else>
{{ section.title }}
</template>
        </h2>
        <p v-for="(paragraph, paragraphIndex) in section.paragraphs" :key="`paragraph-${paragraphIndex}`">
          <GbproRichText :text="paragraph" />
        </p>

        <div v-if="isSplitMediaSection(section)" class="gbpro-section-split-media">
          <div class="gbpro-section-split-media__copy">
            <p v-if="section.subtitle" class="gbpro-item-title">
{{ section.subtitle }}
</p>
            <ul v-if="section.list">
              <li v-for="item in section.list" :key="item">
{{ item }}
</li>
            </ul>
            <p v-for="(paragraph, paragraphIndex) in section.after" :key="`split-after-${paragraphIndex}`">
              <GbproRichText :text="paragraph" />
            </p>
          </div>
          <div class="gbpro-section-split-media__image">
            <img :src="section.image" :alt="section.imageAlt || section.title" loading="lazy">
          </div>
        </div>

        <div v-if="section.split" class="gbpro-why-split">
          <div class="gbpro-why-col">
            <p v-if="section.split.left.subtitle" class="gbpro-item-title">
{{ section.split.left.subtitle }}
</p>
            <ul v-if="section.split.left.list">
              <li v-for="item in section.split.left.list" :key="item">
{{ item }}
</li>
            </ul>
            <p v-for="(paragraph, paragraphIndex) in section.split.left.after" :key="`split-left-after-${paragraphIndex}`">
              <GbproRichText :text="paragraph" />
            </p>
          </div>
          <div class="gbpro-why-col gbpro-why-col--feedback">
            <p v-if="section.split.right.subtitle" class="gbpro-item-title">
{{ section.split.right.subtitle }}
</p>
            <div v-for="item in section.split.right.feedback" :key="item.text" class="gbpro-feedback">
              <p class="gbpro-feedback__text">
                <span class="gbpro-feedback__dot" aria-hidden="true" />"{{ item.text }}"
                <span class="gbpro-feedback__author">
                  &mdash; {{ item.author }} ({{ item.location }} <span class="gbpro-feedback__flag">{{ item.flag || item.code }}</span>)
                </span>
              </p>
            </div>
          </div>
        </div>

        <p v-if="section.subtitle && !isSplitMediaSection(section)" class="gbpro-item-title">
{{ section.subtitle }}
</p>
        <div v-if="section.image && !isSplitMediaSection(section)" class="gbpro-section-image">
          <img :src="section.image" :alt="section.imageAlt || section.title" loading="lazy">
        </div>
        <div v-if="section.list && section.listLayout === 'pills' && !isSplitMediaSection(section)" class="gbpro-pill-list">
          <span v-for="item in section.list" :key="item" class="gbpro-pill-list__item">
{{ item }}
</span>
        </div>
        <div v-if="section.list && section.listLayout === 'file-specs' && !isSplitMediaSection(section)" class="gbpro-file-specs">
          <article
            v-for="(item, itemIndex) in section.list"
            :key="item"
            :class="fileSpecClass(itemIndex)">
            <span class="gbpro-file-spec__icon" aria-hidden="true">
              <GbproHeroIcon :name="fileInfoIcon(item)" tone="soft" />
            </span>
            <span class="gbpro-file-spec__label">{{ fileInfoLabel(item) }}</span>
            <strong class="gbpro-file-spec__value">{{ fileInfoValue(item) }}</strong>
          </article>
        </div>
        <ul v-if="section.list && section.listLayout !== 'pills' && section.listLayout !== 'file-specs' && !isSplitMediaSection(section)">
          <li v-for="item in section.list" :key="item">
{{ item }}
</li>
        </ul>
        <div v-if="section.ordered && section.orderedLayout === 'arrow-flow'" class="gbpro-arrow-flow">
          <div v-for="(item, itemIndex) in section.ordered" :key="item" class="gbpro-arrow-flow__item">
            <span class="gbpro-arrow-flow__number">{{ itemIndex + 1 }}</span>
            <span class="gbpro-arrow-flow__text">{{ item }}</span>
          </div>
        </div>
        <ol v-if="section.ordered && section.orderedLayout !== 'arrow-flow'">
          <li v-for="item in section.ordered" :key="item">
{{ item }}
</li>
        </ol>

        <div v-if="section.cards" class="gbpro-card-grid">
          <article v-for="card in section.cards" :key="card.title" class="gbpro-card">
            <span v-if="card.icon" class="gbpro-card__icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path :d="iconPath(card.icon)" />
              </svg>
            </span>
            <strong class="gbpro-card__title">{{ card.title }}</strong>
            <p v-if="card.text">
{{ card.text }}
</p>
            <ul v-if="card.list" class="gbpro-card__list">
              <li v-for="item in card.list" :key="item">
{{ item }}
</li>
            </ul>
            <p v-if="card.after" class="gbpro-card__after">
{{ card.after }}
</p>
          </article>
        </div>

        <div v-if="section.steps" :class="['gbpro-steps', { 'gbpro-steps--timeline': section.stepsLayout === 'timeline' }]">
          <article v-for="(step, stepIndex) in section.steps" :key="step.title" class="gbpro-step">
            <span v-if="section.stepsLayout === 'timeline'" class="gbpro-step__marker">{{ stepIndex + 1 }}</span>
            <div class="gbpro-step__body">
              <p class="gbpro-item-title">
{{ step.title }}
</p>
              <p>
                <GbproRichText :text="step.text" />
              </p>
            </div>
          </article>
        </div>

        <div v-if="section.quotes" class="gbpro-quotes">
          <blockquote v-for="quote in section.quotes" :key="quote">
{{ quote }}
</blockquote>
        </div>

        <div
          v-if="section.twoColumns"
          :class="twoColumnsClass(section)">
          <div v-for="column in section.twoColumns" :key="column.title" class="gbpro-column">
            <p class="gbpro-item-title">
{{ column.title }}
</p>
            <div v-if="section.twoColumnsLayout === 'pills'" class="gbpro-pill-list gbpro-pill-list--column">
              <span
                v-for="item in column.items"
                :key="item"
                :class="pillItemClass(column)">
{{ item }}
</span>
            </div>
            <ul v-else>
              <li v-for="item in column.items" :key="item">
{{ item }}
</li>
            </ul>
          </div>
        </div>

        <div v-if="section.compare" class="gbpro-compare-wrap">
          <table class="gbpro-compare-table">
            <thead>
              <tr>
                <th v-for="(col, colIndex) in section.compare.columns" :key="col" :class="{ 'is-gb': colIndex === 1 }">
{{ col }}
</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in section.compare.rows" :key="row.feature">
                <td class="gbpro-compare-feature">
{{ row.feature }}
</td>
                <td class="is-gb">
                  <span :class="['gbpro-compare-cell', `gbpro-compare-cell--${row.gb.type}`]">
                    <span v-if="row.gb.type" :class="['gbpro-compare-icon', `gbpro-compare-icon--${row.gb.type}`]" aria-hidden="true">{{ statusMark(row.gb.type) }}</span>
                    {{ row.gb.text }}
                  </span>
                </td>
                <td>
                  <span :class="['gbpro-compare-cell', `gbpro-compare-cell--${row.official.type}`]">
                    <span v-if="row.official.type" :class="['gbpro-compare-icon', `gbpro-compare-icon--${row.official.type}`]" aria-hidden="true">{{ statusMark(row.official.type) }}</span>
                    {{ row.official.text }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="section.compareSummary" class="gbpro-compare-summary">
          <div v-for="column in section.compareSummary" :key="column.title" class="gbpro-compare-summary__col">
            <p class="gbpro-item-title">
{{ column.title }}
</p>
            <ul>
              <li v-for="item in column.items" :key="item">
{{ item }}
</li>
            </ul>
          </div>
        </div>

        <ul v-if="section.linkList" class="gbpro-link-list">
          <li v-for="item in section.linkList" :key="item.href">
            <a :href="item.href" class="gbpro-inline-link">
{{ item.text }}
</a>
            <span v-if="item.note">
 – {{ item.note }}
</span>
          </li>
        </ul>

        <div v-if="section.table" class="gbpro-table-wrap">
          <table :class="tableClass(section.table)">
            <thead>
              <tr>
                <th
                  v-for="(header, headerIndex) in section.table.headers"
                  :key="header"
                  :class="tableHeaderClass(headerIndex, section.table.headers)">
{{ header }}
</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rowIndex) in section.table.rows" :key="rowIndex">
                <td
                  v-for="(cell, cellIndex) in row"
                  :key="`${rowIndex}-${cellIndex}`"
                  :class="tableCellClass(cellIndex, section.table)">
                  <span v-if="isVersionBadge(section.table, cellIndex)" class="gbpro-table-chip gbpro-table-chip--version">
{{ cell }}
</span>
                  <span v-else-if="isMetaBadge(section.table, cellIndex)" class="gbpro-table-chip gbpro-table-chip--meta">
{{ cell }}
</span>
                  <template v-else>
{{ cell }}
</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="section.faqs" class="gbpro-faqs">
          <article v-for="faq in section.faqs" :key="faq.q" class="gbpro-faq">
            <p class="gbpro-item-title">
{{ faq.q }}
</p>
            <p>{{ faq.a }}</p>
          </article>
        </div>

        <template v-if="!isSplitMediaSection(section)">
          <p v-for="(paragraph, paragraphIndex) in section.after" :key="`after-${paragraphIndex}`">
            <GbproRichText :text="paragraph" />
          </p>
        </template>

        <div v-if="section.contactForm" class="gbpro-contact-form-wrap">
          <form class="gbpro-contact-form" @submit.prevent="submitContactForm">
            <label class="gbpro-contact-form__field">
              <span>Name</span>
              <input v-model.trim="contactForm.name" type="text" name="name" autocomplete="name" required>
            </label>
            <label class="gbpro-contact-form__field">
              <span>Email</span>
              <input v-model.trim="contactForm.email" type="email" name="email" autocomplete="email" required>
            </label>
            <label class="gbpro-contact-form__field">
              <span>Subject</span>
              <input v-model.trim="contactForm.subject" type="text" name="subject" required>
            </label>
            <label class="gbpro-contact-form__field">
              <span>Message</span>
              <textarea v-model.trim="contactForm.message" name="message" rows="5" required />
            </label>
            <button class="gbpro-btn gbpro-btn--primary" type="submit" :disabled="contactSubmitting">
              {{ contactSubmitting ? 'Sending...' : 'Send Message' }}
            </button>
            <p v-if="contactSuccess" class="gbpro-contact-form__success" role="status">
              Thank you. Your message has been prepared. We aim to respond within 2–5 business days.
            </p>
          </form>
        </div>

        <button v-if="section.cta" class="gbpro-btn gbpro-btn--primary gbpro-section-cta" @click="downloadApk">
          {{ section.cta }}
        </button>

        <div v-if="section.ctaBanner" class="gbpro-cta-banner">
          <span class="gbpro-cta-banner__icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="34" height="34" fill="currentColor">
              <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm5.3 14.2c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1a12 12 0 0 1-5.4-4.7c-.4-.6-.9-1.5-.9-2.3 0-.8.4-1.2.6-1.4.2-.2.4-.3.6-.3h.5c.2 0 .4 0 .6.5l.7 1.7c.1.2 0 .4 0 .5l-.3.4-.3.3c-.1.1-.2.3-.1.5.2.4.7 1.1 1.4 1.7.9.8 1.6 1 1.9 1.2.2.1.4 0 .5-.1l.7-.8c.2-.2.3-.2.5-.1l1.7.8c.2.1.4.2.4.3.1.2.1.7-.1 1.3Z" />
            </svg>
          </span>
          <div class="gbpro-cta-banner__copy">
            <strong>{{ section.ctaBanner.title }}</strong>
            <span>{{ section.ctaBanner.text }}</span>
          </div>
          <div class="gbpro-cta-banner__action">
            <button class="gbpro-btn gbpro-btn--primary" @click="downloadApk">
              <span class="gbpro-btn__icon gbpro-btn__icon--download" aria-hidden="true" />
              {{ section.ctaBanner.button }}
            </button>
            <span v-if="section.ctaBanner.meta" class="gbpro-cta-banner__meta">{{ section.ctaBanner.meta }}</span>
          </div>
        </div>

        <div v-if="section.visual === 'download-safety'" class="gbpro-warning-panel" role="note">
          <span class="gbpro-warning-panel__alert" aria-hidden="true">!</span>
          <div class="gbpro-warning-panel__copy">
            <strong>Before You Install</strong>
            <span>Check source, version, and Android permissions before installing this APK file.</span>
          </div>
          <span class="gbpro-warning-panel__badge" aria-hidden="true">APK</span>
        </div>
      </section>
    </article>
  </main>
</div>
</template>

<script>
import '@/css/gbpro-theme.scss'
import '@/css/base.scss'
import '@/css/index.scss'
import HeadNav from '@/components/HeadNav.vue'
import GbproHeroIcon from '@/components/GbproHeroIcon.vue'
import GbproRichText from '@/components/GbproRichText.vue'
import downloadHeroIcon from '@/assets/gbwhatspro-chat/03-hero-3d-app-icon.webp'
import { apkMeta, apkRequest, contactEmail, pages } from '@/data/gbwhatsproPages'

export default {
	name: 'SitePage',
	components: {
		HeadNav,
		GbproHeroIcon,
		GbproRichText,
	},
	props: {
		pageKey: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			apk: null,
			from: 'gb',
			filename: 'gb',
			isDownloading: false,
			apkMeta,
			downloadHeroIcon,
			contactEmail,
			contactSubmitting: false,
			contactSuccess: false,
			contactForm: {
				name: '',
				email: '',
				subject: '',
				message: '',
			},
		}
	},
	computed: {
		page() {
			return pages[this.pageKey]
		},
		isLegal() {
			return ['privacy', 'terms', 'disclaimer', 'contact'].includes(this.pageKey)
		},
	},
	mounted() {
		this.from = this.$global.GetQueryString('from') || this.from
		this.filename = this.$global.GetQueryString('filename') || this.filename
		if (this.$global.GetQueryString('from')) {
			this.getAPK()
		} else {
			this.getOfficalApk()
		}
	},
	methods: {
		slugify(value) {
			return value
				.toLowerCase()
				.replace(/&/g, 'and')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/(^-|-$)/g, '')
		},
		sectionId(section, index) {
			const title = section.title
				? `${section.title}${section.titleAccent ? ` ${section.titleAccent}` : ''}`
				: ''
			return title ? this.slugify(title) : `section-${index + 1}`
		},
		heroTitlePrefix(hero) {
			return hero.title.replace(hero.titleAccent, '').trim()
		},
		heroTitleMain(hero) {
			if (!hero.title || !hero.title.includes('|')) return hero.title || ''
			return hero.title.split('|')[0].trim()
		},
		heroTitleSuffix(hero) {
			if (!hero.title || !hero.title.includes('|')) return ''
			return hero.title.split('|').slice(1).join('|').trim()
		},
		isSplitMediaSection(section) {
			return section.mediaLayout === 'split' && section.image
		},
		sectionClass(section) {
			return {
				'gbpro-section': true,
				'gbpro-section--compare': section.compare,
				'gbpro-section--file-specs': section.listLayout === 'file-specs',
				'gbpro-section--pills': section.listLayout === 'pills',
				'gbpro-section--steps': section.steps,
				'gbpro-section--warning': section.variant === 'warning',
				'gbpro-section--data-table': section.table,
			}
		},
		fileSpecClass(itemIndex) {
			return {
				'gbpro-file-spec': true,
				'gbpro-file-spec--featured': itemIndex === 0,
			}
		},
		twoColumnsClass(section) {
			return {
				'gbpro-two': true,
				'gbpro-two--pills': section.twoColumnsLayout === 'pills',
			}
		},
		pillItemClass(column) {
			return {
				'gbpro-pill-list__item': true,
				'gbpro-pill-list__item--con': this.isConColumn(column),
			}
		},
		isConColumn(column) {
			return column.title && column.title.toLowerCase().indexOf('cons') === 0
		},
		fileInfoLabel(item) {
			return item.split(':')[0]
		},
		fileInfoValue(item) {
			const parts = item.split(':')
			return parts.length > 1 ? parts.slice(1).join(':').trim() : item
		},
		fileInfoIcon(item) {
			const label = this.fileInfoLabel(item).toLowerCase()
			if (label.indexOf('android') !== -1) return 'android'
			if (label.indexOf('size') !== -1) return 'size'
			if (label.indexOf('type') !== -1) return 'download'
			return 'version'
		},
		tableClass(table) {
			return {
				'gbpro-data-table': true,
				[`gbpro-data-table--cols-${table.headers.length}`]: true,
			}
		},
		tableHeaderClass(headerIndex, headers) {
			const lastIndex = headers.length - 1
			return {
				'is-feature': headerIndex === 0,
				'is-mid': headerIndex === 1 && headers.length === 3,
				'is-accent': headerIndex === lastIndex && headers.length > 1,
			}
		},
		tableCellClass(cellIndex, table) {
			const lastIndex = table.headers.length - 1
			return {
				'is-feature': cellIndex === 0,
				'is-mid': cellIndex === 1 && table.headers.length === 3,
				'is-accent': cellIndex === lastIndex && table.headers.length > 1,
				'is-value': cellIndex === lastIndex && table.headers.length === 2,
			}
		},
		isVersionBadge(table, cellIndex) {
			return table.headers[0] === 'Version' && cellIndex === 0
		},
		isMetaBadge(table, cellIndex) {
			return table.headers[0] === 'Version' && cellIndex > 0
		},
		iconPath(name) {
			const icons = {
				privacy: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z',
				themes: 'M12 2.7 6.3 8.4a8 8 0 1 0 11.4 0L12 2.7z',
				'anti-delete': 'M21 11.5a8.5 8.5 0 0 1-12.4 7.5L3 21l2-5.6A8.5 8.5 0 1 1 21 11.5z',
				media: 'M4 5h16v14H4z M8 11l-4 6h16l-6-8-3 4-2-2z',
				lock: 'M5 11h14v10H5z M8 11V7a4 4 0 0 1 8 0v4',
				dnd: 'M21 12.8A9 9 0 1 1 11.2 3 7 7 0 0 0 21 12.8z',
				accounts: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2 M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z M22 21v-2a4 4 0 0 0-3-3.9 M16 3.1a4 4 0 0 1 0 7.8',
				'auto-reply': 'M9 14 4 9l5-5 M4 9h11a5 5 0 0 1 5 5v6',
				scheduler: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
				hidden: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z',
				status: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4 M7 10l5 5 5-5 M12 15V3',
				controls: 'M4 21v-7 M4 10V3 M12 21v-9 M12 8V3 M20 21v-5 M20 12V3 M1 14h6 M9 8h6 M17 16h6',
			}
			return icons[name] || icons.privacy
		},
		statusMark(type) {
			const marks = { yes: '\u2713', no: '\u2715', warn: '!', block: '\u2715' }
			return marks[type] || ''
		},
		getAPK() {
			return this.$server
				.getAPPInfo({
					promotionChannel: this.from,
					promotionName: this.filename,
				})
				.then((res) => {
					if (res.code == 200) {
						this.apk = res.data.apk || this.$global.downloadUrl
					} else {
						this.apk = this.$global.downloadUrl
					}
					return this.apk
				})
		},
		getOfficalApk() {
			return this.$server
				.getOfficalApk(apkRequest)
				.then((res) => {
					if (res.code == 200) {
						this.apk = res.data.apk || this.$global.downloadUrl
					} else {
						this.apk = this.$global.downloadUrl
					}
					return this.apk
				})
		},
		downloadApk() {
			if (this.pageKey !== 'download') {
				this.$router.push('/download/')
				return
			}
			if (this.apk) {
				this.$global.download(this.apk)
				return
			}
			if (this.isDownloading) return
			this.isDownloading = true
			const request = this.$global.GetQueryString('from') ? this.getAPK() : this.getOfficalApk()
			request
				.then((apk) => {
					if (apk) {
						this.$global.download(apk)
					}
				})
				.finally(() => {
					this.isDownloading = false
				})
		},
		submitContactForm() {
			if (this.contactSubmitting) return
			this.contactSubmitting = true
			const subject = encodeURIComponent(this.contactForm.subject)
			const body = encodeURIComponent(
				`Name: ${this.contactForm.name}\nEmail: ${this.contactForm.email}\n\n${this.contactForm.message}`
			)
			window.location.href = `mailto:${this.contactEmail}?subject=${subject}&body=${body}`
			this.contactSuccess = true
			this.contactSubmitting = false
		},
	},
}
</script>

<style lang="scss" scoped>
.gbpro-page {
	--fs-body: 0.95rem;
	--fs-body-lg: 1.02rem;
	--fs-small: 0.84rem;
	--fs-xs: 0.76rem;
	--fs-eyebrow: 0.72rem;
	--fs-btn: 0.9rem;
	--fs-h1: clamp(1.55rem, 3.6vw, 2.65rem);
	--fs-h2: clamp(1.4rem, 3vw, 1.9rem);
	--fs-h3: 1.12rem;
	--fs-item-title: 1.02rem;
	--fs-hero-sub: clamp(0.9rem, 1.6vw, 1rem);
	--lh-body: 1.65;
	min-height: 100vh;
	background:
		radial-gradient(circle at 50% 0%, rgba(37, 211, 102, 0.08), transparent 42%),
		radial-gradient(circle at 12% 18%, rgba(37, 211, 102, 0.05), transparent 32%),
		linear-gradient(180deg, var(--gb-bg-deep) 0%, var(--gb-bg) 48%, var(--gb-bg-deep) 100%);
	color: var(--gb-text);
	overflow-x: hidden;
	font-size: var(--fs-body);
	line-height: var(--lh-body);
}

.gbpro-main {
	overflow-x: hidden;
	padding-inline: var(--gb-page-x);
}

.gbpro-hero {
	position: relative;
	background:
		radial-gradient(circle at 50% 42%, rgba(37, 211, 102, 0.14), transparent 38%),
		radial-gradient(circle at 42% 78%, rgba(37, 211, 102, 0.06), transparent 34%),
		linear-gradient(180deg, var(--gb-bg) 0%, var(--gb-bg-deep) 100%);
	color: var(--gb-text);
	padding: 68px 0 60px;
	border-bottom: 1px solid var(--gb-line);

	&--download,
	&--simple,
	&--legal {
		background:
			radial-gradient(circle at 50% 18%, rgba(37, 211, 102, 0.1), transparent 36%),
			linear-gradient(180deg, var(--gb-bg-soft) 0%, var(--gb-bg-deep) 100%);
		color: var(--gb-text);
	}

	&--legal {
		padding: 54px 0 34px;
		text-align: center;
	}
}

.gbpro-hero--legal .gbpro-hero__inner {
	display: grid;
	grid-template-columns: 1fr;
	justify-items: center;
	text-align: center;
}

.gbpro-hero--legal .gbpro-hero__copy {
	width: 100%;
}

.gbpro-hero__inner {
	width: 100%;
	margin: 0 auto;
	display: grid;
	grid-template-columns: minmax(0, 1.15fr) minmax(280px, 0.85fr);
	gap: 38px;
	align-items: center;
}

.gbpro-hero--home {
	padding: 52px 34px 60px 34px;
	overflow: hidden;
	background:
		radial-gradient(ellipse 70% 80% at 50% 46%, rgba(37, 211, 102, 0.2), transparent 68%),
		radial-gradient(circle at 18% 12%, rgba(37, 211, 102, 0.07), transparent 38%),
		radial-gradient(circle at 82% 18%, rgba(37, 211, 102, 0.05), transparent 34%),
		linear-gradient(180deg, #06140d 0%, var(--gb-bg-deep) 52%, var(--gb-bg) 100%);
}

.gbpro-hero--home .gbpro-hero__inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: clamp(18px, 2.8vw, 36px);
	width: 100%;
	max-width: none;
	margin: 0 auto;
}

.gbpro-hero--home .gbpro-hero__copy {
	flex: 1 1 720px;
	max-width: 760px;
	min-width: 0;
}

.gbpro-hero--home h1 {
	display: inline-grid;
	grid-template-columns: minmax(0, max-content);
	width: max-content;
	max-width: 100%;
	margin-bottom: 18px;
	font-size: inherit;
}

.gbpro-hero--home .gbpro-hero-title-line--main {
	font-size: clamp(2.15rem, 4.4vw, 3.45rem);
	font-weight: 800;
	line-height: 1.06;
}

.gbpro-hero--home .gbpro-hero-title-line--sub {
	font-size: clamp(1.2rem, 2.1vw, 1.75rem);
	font-weight: 800;
	line-height: 1.12;
}

.gbpro-hero--home .gbpro-badges {
	display: flex;
	flex-wrap: nowrap;
	margin-top: 24px;
	gap: 1em;

	span {
		display: inline-flex;
		align-items: center;
		gap: 0.5em;
		flex: 0 0 auto;
		white-space: nowrap;
	}
}

.gbpro-hero--home .gbpro-actions {
	display: flex;
	flex-wrap: nowrap;
	align-items: center;
	margin-top: 24px;
	gap: 0.75em;
}

.gbpro-hero--home .gbpro-btn {
	flex: 0 0 auto;
	white-space: nowrap;
}

.gbpro-hero--home .gbpro-btn--secondary::after {
	content: '\2192';
	margin-left: 4px;
	font-size: 1.05em;
	line-height: 1;
}

.gbpro-hero--home .gbpro-hero__art {
	flex: 0 0 auto;
}

.gbpro-hero--home .gbpro-download-card {
	flex: 0 0 min(288px, 100%);
	align-self: center;
	background: rgba(18, 18, 18, 0.72);
	backdrop-filter: blur(16px);
	border: 1px solid rgba(255, 255, 255, 0.1);
	box-shadow:
		0 22px 48px rgba(0, 0, 0, 0.42),
		0 0 0 1px rgba(37, 211, 102, 0.08);
}

.gbpro-hero--home .gbpro-hero__art .gbpro-hero-icon {
	width: min(300px, 34vw);
	filter: drop-shadow(0 28px 56px rgba(37, 211, 102, 0.35));
}

.gbpro-hero--home .gbpro-hero__art::before {
	inset: auto;
	left: 50%;
	top: 52%;
	width: min(260px, 52vw);
	height: min(260px, 52vw);
	transform: translate(-50%, -50%);
	border-radius: 50%;
	background:
		radial-gradient(circle, rgba(37, 211, 102, 0.38) 0%, rgba(37, 211, 102, 0.14) 42%, transparent 72%);
	filter: blur(6px);
}

.gbpro-hero--home .gbpro-hero__art::after {
	position: absolute;
	left: 50%;
	bottom: 10%;
	width: min(200px, 42vw);
	height: 44px;
	border-radius: 50%;
	background: radial-gradient(ellipse, rgba(37, 211, 102, 0.55) 0%, transparent 72%);
	filter: blur(14px);
	content: '';
	transform: translateX(-50%);
}

.gbpro-hero--apk-download {
	overflow: visible;
	padding: 0;
	border: 0;
	border-radius: 0;
	background: transparent;
	box-shadow: none;
}

.gbpro-hero--apk-download .gbpro-hero__inner {
	position: relative;
	z-index: 1;
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(220px, 300px);
	gap: 14px;
	align-items: stretch;
}

.gbpro-hero--apk-download .gbpro-hero__copy {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	width: 100%;
	min-height: auto;
	padding: clamp(22px, 2.8vw, 34px);
	border: 1px solid rgba(37, 211, 102, 0.24);
	border-left: 5px solid var(--gb-green-bright);
	border-radius: 14px;
	background:
		linear-gradient(180deg, rgba(255, 255, 255, 0.045), rgba(255, 255, 255, 0.012)),
		rgba(7, 16, 11, 0.82);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 24px 44px rgba(0, 0, 0, 0.24);
}

.gbpro-hero.gbpro-hero--apk-download .gbpro-eyebrow {
	width: fit-content;
	margin-bottom: 20px;
	border-color: rgba(37, 211, 102, 0.36);
	background: rgba(0, 0, 0, 0.28);
	box-shadow: 0 0 0 4px rgba(37, 211, 102, 0.06);
}

.gbpro-hero.gbpro-hero--apk-download h1 {
	max-width: 100%;
	margin-bottom: 14px;
}

.gbpro-hero--apk-download .gbpro-hero-title-line {
	white-space: nowrap;
}

.gbpro-hero--apk-download .gbpro-hero-title-line--main {
	font-size: clamp(1.6rem, 2.8vw, 2.15rem);
	font-weight: 800;
	line-height: 1.08;
}

.gbpro-hero--apk-download .gbpro-hero-title-accent {
	display: inline-flex;
	align-items: center;
	margin-left: 0.36em;
	padding: 0.24em 0.48em;
	border: 1px solid rgba(37, 211, 102, 0.44);
	border-radius: 999px;
	background: rgba(37, 211, 102, 0.12);
	color: var(--gb-green-bright);
	font-size: 0.42em;
	line-height: 1;
	white-space: nowrap;
	text-shadow: none;
	transform: translateY(-0.12em);
}

.gbpro-hero--apk-download .gbpro-hero-line {
	max-width: 720px;
	color: rgba(255, 255, 255, 0.78);
	font-family: Consolas, 'Courier New', monospace;
	font-size: clamp(0.86rem, 1.4vw, 0.98rem);
}

.gbpro-hero--apk-download .gbpro-badges {
	margin-top: 16px;
	gap: 9px;
}

.gbpro-hero.gbpro-hero--apk-download .gbpro-badges span {
	gap: 8px;
	padding: 8px 11px;
	border: 1px solid rgba(37, 211, 102, 0.28);
	background: rgba(37, 211, 102, 0.1);
	color: var(--gb-text);
	box-shadow: none;

	.gbpro-ui-icon {
		--gb-ui-icon-box: 1.16em;
		background: var(--gb-green-bright);
		color: #fff;
		box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.12);

		svg {
			width: 0.72em;
			height: 0.72em;
		}
	}
}

.gbpro-hero--apk-download .gbpro-actions {
	margin-top: 18px;
}

.gbpro-hero--apk-download .gbpro-btn--primary {
	min-height: 46px;
	padding-inline: 20px;
	border-radius: 999px;
	box-shadow: 0 14px 34px rgba(37, 211, 102, 0.2);
}

.gbpro-hero.gbpro-hero--apk-download .gbpro-btn--secondary {
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.06);
}

.gbpro-hero-side {
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-height: auto;
	padding: 16px 18px;
	overflow: hidden;
	border: 1px solid rgba(37, 211, 102, 0.24);
	border-radius: 14px;
	background:
		linear-gradient(135deg, rgba(37, 211, 102, 0.12), rgba(255, 255, 255, 0.025) 46%, rgba(37, 211, 102, 0.06)),
		rgba(5, 14, 9, 0.76);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 18px 34px rgba(0, 0, 0, 0.22);

	&::before {
		position: absolute;
		top: 16px;
		right: 16px;
		width: 56px;
		height: 56px;
		border-top: 1px solid rgba(37, 211, 102, 0.32);
		border-right: 1px solid rgba(37, 211, 102, 0.32);
		content: '';
	}

	&::after {
		position: absolute;
		right: 18px;
		bottom: 18px;
		left: 18px;
		height: 1px;
		background: linear-gradient(90deg, rgba(37, 211, 102, 0.42), transparent);
		content: '';
	}

	> strong {
		margin-top: 12px;
		color: var(--gb-text);
		font-size: clamp(1rem, 1.45vw, 1.15rem);
		font-weight: 800;
		line-height: 1.2;
	}

	> p {
		margin: 6px 0 0;
		color: rgba(255, 255, 255, 0.72);
		font-size: var(--fs-xs);
		line-height: 1.5;
	}
}

.gbpro-hero-side__mark {
	display: inline-flex;
	align-items: center;
	align-self: flex-start;
	gap: 7px;
	padding: 6px 9px;
	border: 1px solid rgba(37, 211, 102, 0.28);
	border-radius: 999px;
	background: rgba(37, 211, 102, 0.1);
	color: var(--gb-green-bright);
	font-size: var(--fs-xs);
	font-weight: 900;
	line-height: 1;
}

.gbpro-hero-side__steps {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 6px;
	margin-top: 13px;

	span {
		display: flex;
		align-items: center;
		gap: 8px;
		min-height: 30px;
		padding: 5px 9px;
		border: 1px solid rgba(255, 255, 255, 0.1);
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.045);
		color: rgba(255, 255, 255, 0.88);
		font-size: var(--fs-xs);
		font-weight: 700;
		line-height: 1.2;

		&:last-child {
			grid-column: 1 / -1;
		}
	}
}

.gbpro-hero-side__step-index {
	display: inline-grid;
	place-items: center;
	flex: 0 0 auto;
	width: 20px;
	height: 20px;
	border: 1px solid rgba(37, 211, 102, 0.36);
	border-radius: 999px;
	background: rgba(37, 211, 102, 0.12);
	color: var(--gb-green-bright);
	font-size: 0.72rem;
	font-weight: 900;
	line-height: 1;
}

.gbpro-hero--apk-download .gbpro-hero__art {
	grid-column: 2;
	grid-row: 1;
	z-index: 3;
	align-self: center;
	justify-self: center;
	width: min(340px, 100%);
	aspect-ratio: 1;
	border: 1px solid rgba(37, 211, 102, 0.3);
	border-radius: 36px;
	background:
		linear-gradient(145deg, rgba(37, 211, 102, 0.16), rgba(255, 255, 255, 0.025) 46%, rgba(37, 211, 102, 0.08)),
		rgba(8, 20, 13, 0.78);
	box-shadow: 0 34px 70px rgba(0, 0, 0, 0.38), 0 0 42px rgba(37, 211, 102, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.06);
	backdrop-filter: blur(12px);

	&::before {
		inset: 12%;
		border: 1px dashed rgba(37, 211, 102, 0.34);
		border-radius: 30px;
		background:
			radial-gradient(circle, rgba(37, 211, 102, 0.32), rgba(37, 211, 102, 0.1) 42%, transparent 68%);
		filter: blur(18px);
	}

	&::after {
		position: absolute;
		right: 24px;
		bottom: 22px;
		z-index: 2;
		padding: 8px 12px;
		border: 1px solid rgba(37, 211, 102, 0.34);
		border-radius: 999px;
		background: rgba(0, 0, 0, 0.28);
		color: var(--gb-green-bright);
		content: 'APK';
		font-size: var(--fs-xs);
		font-weight: 900;
		letter-spacing: 0.12em;
	}
}

.gbpro-hero--apk-download .gbpro-hero-icon {
	width: min(220px, 68%);
	filter: drop-shadow(0 24px 44px rgba(37, 211, 102, 0.38));
}

.gbpro-hero--apk-download .gbpro-download-card {
	position: relative;
	grid-column: 2;
	grid-row: 1;
	align-self: end;
	justify-self: stretch;
	width: 100%;
	min-height: 318px;
	padding: 112px 24px 24px;
	border-color: rgba(37, 211, 102, 0.3);
	border-radius: 18px;
	background:
		linear-gradient(180deg, rgba(37, 211, 102, 0.13), rgba(255, 255, 255, 0.02) 38%),
		rgba(10, 18, 14, 0.92);
	box-shadow: 0 30px 58px rgba(0, 0, 0, 0.38), inset 0 1px 0 rgba(255, 255, 255, 0.06);

	&::before {
		position: absolute;
		top: 24px;
		left: 24px;
		color: var(--gb-green-bright);
		content: 'APK PACKAGE';
		font-size: var(--fs-xs);
		font-weight: 900;
		letter-spacing: 0.14em;
	}
}

.gbpro-hero--apk-download .gbpro-download-card .gbpro-download-card__row {
	padding: 13px 0;
}

.gbpro-hero--apk-download .gbpro-download-card button {
	border-radius: 999px;
}

.gbpro-hero--apk-download {
	overflow: hidden;
	padding: clamp(26px, 3.8vw, 42px) clamp(18px, 4vw, 38px);
	border: 1px solid rgba(37, 211, 102, 0.26);
	border-radius: 8px;
	background:
		radial-gradient(circle at 50% 12%, rgba(37, 211, 102, 0.22), transparent 30%),
		radial-gradient(circle at 80% 20%, rgba(37, 211, 102, 0.13), transparent 28%),
		linear-gradient(135deg, #03150d 0%, #062a19 52%, #02110b 100%);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 26px 70px rgba(0, 0, 0, 0.28);
}

.gbpro-hero--apk-download .gbpro-hero__inner {
	display: flex;
	align-items: center;
	justify-content: center;
	max-width: 760px;
	min-height: 250px;
	margin: 0 auto;
	text-align: center;
}

.gbpro-hero--apk-download .gbpro-hero__copy {
	align-items: center;
	width: 100%;
	min-height: auto;
	padding: 0;
	border: 0;
	background: transparent;
	box-shadow: none;
}

.gbpro-download-hero-mark {
	position: relative;
	width: clamp(76px, 9vw, 96px);
	height: clamp(76px, 9vw, 96px);
	margin: 0 auto 12px;
}

.gbpro-download-hero-mark img {
	display: block;
	width: 100%;
	height: 100%;
	object-fit: contain;
	filter: drop-shadow(0 18px 34px rgba(37, 211, 102, 0.36));
}

.gbpro-download-hero-title {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	margin: 0 0 10px;
	color: #fff;
	line-height: 1.08;
	text-align: center;
	text-shadow: 0 3px 20px rgba(0, 0, 0, 0.28);
}

.gbpro-download-hero-title span {
	font-size: clamp(1.9rem, 3.7vw, 2.8rem);
	font-weight: 900;
}

.gbpro-download-hero-title strong {
	color: var(--gb-green-bright);
	font-size: clamp(1.7rem, 3.2vw, 2.45rem);
	font-weight: 900;
}

.gbpro-hero--apk-download .gbpro-hero-line {
	max-width: 620px;
	margin: 0 auto 4px;
	color: rgba(255, 255, 255, 0.78);
	font-family: inherit;
	font-size: clamp(0.92rem, 1.2vw, 1rem);
	line-height: 1.55;
	text-align: center;
}

.gbpro-hero--apk-download .gbpro-actions {
	justify-content: center;
	margin-top: 16px;
}

.gbpro-hero--apk-download .gbpro-btn--primary {
	min-height: 52px;
	padding: 0 28px;
	border-radius: 8px;
	font-size: clamp(0.95rem, 1.3vw, 1.05rem);
	box-shadow: 0 18px 40px rgba(37, 211, 102, 0.32);
}

.gbpro-hero--home .gbpro-eyebrow {
	display: inline-flex;
	align-items: center;
	gap: 0.55em;
}

.gbpro-hero--compact {
	padding: 36px 0 42px;

	&.gbpro-hero--home {
		padding: 36px 24px 42px;
	}

	&.gbpro-hero--download .gbpro-hero__copy {
		min-height: auto;
		padding: clamp(28px, 4vw, 52px);
	}

	.gbpro-hero__inner {
		gap: clamp(14px, 2vw, 28px);
	}

	.gbpro-hero__copy {
		flex: 1 1 520px;
		max-width: 620px;
	}

	.gbpro-hero-title-line--main {
		font-size: clamp(1.7rem, 3vw, 2.35rem);
	}

	.gbpro-hero-title-line--sub {
		font-size: clamp(1.05rem, 1.8vw, 1.45rem);
	}

	.gbpro-eyebrow {
		margin-bottom: 16px;
	}

	.gbpro-hero-line {
		margin-bottom: 0;
		font-size: clamp(0.86rem, 1.4vw, 0.95rem);
	}

	.gbpro-badges {
		margin-top: 16px;
	}

	.gbpro-actions {
		margin-top: 16px;
	}

	.gbpro-hero__art .gbpro-hero-icon {
		width: min(220px, 26vw);
	}

	.gbpro-download-card {
		padding: 20px 18px;
	}
}

.gbpro-hero--centered .gbpro-hero__inner {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: min(760px, 100%);
	text-align: center;
}

.gbpro-hero--centered .gbpro-hero__art {
	order: -1;
	margin-bottom: 6px;
}

.gbpro-hero--centered .gbpro-hero-icon {
	width: min(150px, 42vw);
}

.gbpro-hero--centered .gbpro-hero__art::before {
	inset: 8% 12% 4%;
}

.gbpro-hero--centered h1 {
	max-width: none;
}

.gbpro-hero--centered .gbpro-hero-line {
	max-width: none;
}

.gbpro-hero--centered .gbpro-actions,
.gbpro-hero--centered .gbpro-badges {
	justify-content: center;
}

.gbpro-hero__copy {
	min-width: 0;
}

.gbpro-eyebrow {
	display: inline-flex;
	align-items: center;
	gap: 0.55em;
	margin: 0 0 26px;
	padding: 0.55em 1em 0.55em 0.55em;
	border-radius: 999px;
	background: var(--gb-green-soft);
	border: 1px solid var(--gb-line-strong);
	color: var(--gb-green-bright);
	font-size: var(--fs-eyebrow);
	font-weight: 700;
	letter-spacing: 0.1em;
	text-transform: uppercase;

	.gbpro-ui-icon {
		--gb-ui-icon-box: 1.35em;
	}
}

.gbpro-hero--download .gbpro-eyebrow,
.gbpro-hero--simple .gbpro-eyebrow {
	background: var(--gb-green-soft);
	color: var(--gb-green-bright);
}

.gbpro-hero--page-pc,
.gbpro-hero--page-ios,
.gbpro-hero--page-old {
	.gbpro-hero__inner {
		display: block;
	}

	h1 {
		max-width: none;
		line-height: 1.2;
		font-size: clamp(1.4rem, 2.6vw, 2.05rem);
	}

	.gbpro-hero-line {
		max-width: none;
		margin-bottom: 14px;
		line-height: 1.62;
	}
}

.gbpro-hero h1 {
	max-width: 820px;
	margin: 0 0 24px;
	font-size: var(--fs-h1);
	font-weight: 800;
	line-height: 1.15;
	letter-spacing: -0.015em;
	color: var(--gb-text);
}

.gbpro-hero--legal h1 {
	margin: 0 auto;
	text-align: center;
	font-size: clamp(1.4rem, 2.6vw, 2.05rem);
}

.gbpro-hero-title-line {
	display: block;
	white-space: nowrap;
}

.gbpro-hero-title-line + .gbpro-hero-title-line {
	margin-top: 4px;
}

.gbpro-hero-title-accent {
	color: var(--gb-green-bright);
	text-shadow: 0 0 20px var(--gb-green-glow);
}

.gbpro-hero-heading {
	display: block;
	width: 100%;
	max-width: none;
	white-space: nowrap;

	&__suffix {
		display: inline-flex;
		align-items: center;
		margin-left: 0.32em;
		padding: 0.18em 0.42em;
		border: 1px solid rgba(37, 211, 102, 0.44);
		border-radius: 999px;
		background: rgba(37, 211, 102, 0.12);
		color: var(--gb-green-bright);
		font-size: 0.34em;
		font-weight: 700;
		line-height: 1;
		white-space: nowrap;
		vertical-align: top;
		text-shadow: none;
	}
}

.gbpro-hero-line {
	max-width: 780px;
	margin: 0 0 6px;
	color: var(--gb-muted);
	font-size: var(--fs-hero-sub);
	line-height: 1.5;
}

.gbpro-badges {
	display: flex;
	flex-wrap: wrap;
	gap: 0.85em;
	margin-top: 34px;

	span {
		display: inline-flex;
		align-items: center;
		gap: 0.5em;
		padding: 0;
		border-radius: 999px;
		background: transparent;
		border: 0;
		color: var(--gb-text);
		font-size: var(--fs-small);
		font-weight: 700;
		line-height: 1.2;

		.gbpro-ui-icon {
			--gb-ui-icon-box: 1.2em;
		}
	}
}

.gbpro-hero--download .gbpro-badges span {
	background: var(--gb-green-soft);
	color: var(--gb-green-bright);
	box-shadow: var(--gb-shadow-green);
}

.gbpro-actions {
	display: flex;
	flex-wrap: wrap;
	gap: 14px;
	margin-top: 36px;
}

.gbpro-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: 0.55em;
	min-height: 2.75em;
	padding: 0.75em 1.15em;
	border: 0;
	border-radius: 8px;
	font-size: var(--fs-btn);
	font-weight: 700;
	line-height: 1;
	cursor: pointer;
	transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;

	.gbpro-ui-icon {
		--gb-ui-icon-box: 1.35em;
	}

	&:hover {
		transform: translateY(-1px);
	}
}

.gbpro-btn__icon {
	position: relative;
	flex: 0 0 22px;
	width: 22px;
	height: 22px;
	border-radius: 999px;
	background: rgba(255, 255, 255, 0.2);
}

.gbpro-btn--primary .gbpro-btn__icon {
	background: rgba(255, 255, 255, 0.22);
}

.gbpro-btn--secondary .gbpro-btn__icon {
	background: rgba(255, 255, 255, 0.08);
}

.gbpro-btn__icon--download::before {
	position: absolute;
	left: 10px;
	top: 5px;
	width: 2px;
	height: 9px;
	border-radius: 999px;
	background: currentColor;
	content: '';
}

.gbpro-btn__icon--download::after {
	position: absolute;
	left: 7px;
	top: 11px;
	width: 6px;
	height: 6px;
	border-right: 2px solid currentColor;
	border-bottom: 2px solid currentColor;
	content: '';
	transform: rotate(45deg);
}

.gbpro-btn__icon--guide::before {
	position: absolute;
	left: 6px;
	top: 5px;
	width: 9px;
	height: 12px;
	border: 2px solid currentColor;
	border-radius: 2px;
	content: '';
}

.gbpro-btn__icon--guide::after {
	position: absolute;
	left: 9px;
	top: 9px;
	width: 6px;
	height: 2px;
	border-radius: 999px;
	background: currentColor;
	box-shadow: 0 4px 0 currentColor;
	content: '';
}

.gbpro-btn--primary {
	background: linear-gradient(180deg, var(--gb-green-bright) 0%, var(--gb-green) 100%);
	color: var(--gb-btn-text);
	box-shadow: var(--gb-shadow-green);
}

.gbpro-btn--secondary {
	background: rgba(255, 255, 255, 0.04);
	color: var(--gb-text);
	border: 1px solid rgba(255, 255, 255, 0.18);
}

.gbpro-hero--download .gbpro-btn--secondary,
.gbpro-hero--simple .gbpro-btn--secondary {
	border-color: rgba(255, 255, 255, 0.18);
	background: rgba(255, 255, 255, 0.04);
	color: var(--gb-text);
}

.gbpro-hero__art {
	position: relative;
	display: grid;
	place-items: center;
	min-width: 0;

	&::before {
		position: absolute;
		inset: 22% 4% 12%;
		border-radius: 999px;
		background:
			radial-gradient(circle, var(--gb-green-glow) 0%, rgba(37, 211, 102, 0.12) 36%, transparent 68%);
		filter: blur(10px);
		content: '';
		transform: rotate(-12deg);
	}
}

.gbpro-hero-icon {
	position: relative;
	z-index: 1;
	width: min(280px, 42vw);
	filter: drop-shadow(0 24px 48px rgba(37, 211, 102, 0.28));
}

.gbpro-download-card {
	width: min(280px, 100%);
	justify-self: end;
	padding: 24px 22px;
	border-radius: 14px;
	background: var(--gb-surface);
	border: 1px solid var(--gb-line);
	color: var(--gb-text);
	box-shadow: var(--gb-shadow-panel), inset 0 1px 0 rgba(255, 255, 255, 0.03);

	.gbpro-download-card__row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 16px;
		padding: 16px 0;
		border-bottom: 1px solid rgba(255, 255, 255, 0.08);
	}

	span {
		display: inline-flex;
		align-items: center;
		gap: 0.65em;
		color: var(--gb-muted);
		font-size: var(--fs-body-lg);
		line-height: 1.2;

		.gbpro-ui-icon {
			--gb-ui-icon-box: 1.35em;
		}
	}

	strong {
		color: var(--gb-text);
		font-size: var(--fs-body-lg);
		font-weight: 800;
	}

	button {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: 12px;
		width: 100%;
		margin-top: 22px;
	}
}

.gbpro-hero-preview {
	width: 100%;
	margin: 34px auto 0;
}

.gbpro-preview-window {
	overflow: hidden;
	border: 1px solid var(--gb-line);
	border-radius: 14px;
	background: var(--gb-surface-strong);
	box-shadow: var(--gb-shadow-panel), 0 0 32px rgba(37, 211, 102, 0.06);
	backdrop-filter: blur(10px);
}

.gbpro-preview-window__bar {
	display: flex;
	gap: 7px;
	padding: 14px 16px;
	background: var(--gb-green-soft);

	span {
		width: 10px;
		height: 10px;
		border-radius: 999px;
		background: var(--gb-green);
	}
}

.gbpro-preview-window__body {
	display: grid;
	grid-template-columns: 1.2fr 1fr 1fr;
	gap: 16px;
	padding: 20px;
}

.gbpro-preview-panel {
	min-height: 116px;
	padding: 20px;
	border: 1px solid var(--gb-line);
	border-radius: 12px;
	background: var(--gb-surface);
	color: var(--gb-text);
	box-shadow: var(--gb-shadow-panel);

	strong,
	span {
		display: block;
	}

	strong {
		margin-bottom: 8px;
		font-size: 1.35rem;
		font-weight: 800;
	}

	span {
		color: var(--gb-muted);
		font-weight: 700;
	}

	&--primary {
		background: linear-gradient(180deg, var(--gb-green-bright) 0%, var(--gb-green) 100%);
		color: var(--gb-btn-text);

		span {
			color: rgba(255, 255, 255, 0.82);
		}
	}
}

.gbpro-content {
	width: 100%;
	margin: 24px auto 54px;
}

.gbpro-section {
	padding: 34px;
	margin-bottom: 18px;
	border: 1px solid var(--gb-line);
	border-radius: 12px;
	background: var(--gb-surface);
	box-shadow: var(--gb-shadow-panel), inset 0 1px 0 rgba(255, 255, 255, 0.03);

	h2 {
		margin: 0 0 18px;
		color: var(--gb-text);
		font-size: var(--fs-h2);
		font-weight: 700;
		line-height: 1.15;
		letter-spacing: -0.015em;
		text-align: left;
	}

	p {
		margin: 0 0 14px;
		color: var(--gb-muted);
		font-size: var(--fs-body-lg);
		line-height: var(--lh-body);
	}

	.gbpro-item-title {
		margin: 22px 0 10px;
		color: var(--gb-green-bright);
		font-size: var(--fs-item-title);
		font-weight: 700;
		line-height: 1.35;
	}

	ul,
	ol {
		margin: 0 0 18px 20px !important;
		color: var(--gb-muted);
	}

	li {
		margin-bottom: 8px;
		line-height: 1.58;
	}
}

.gbpro-content--legal {
	margin-top: 22px;

	.gbpro-section {
		padding: 0;
		margin-bottom: 30px;
		border: 0;
		border-radius: 0;
		background: transparent;
		box-shadow: none;
	}

	.gbpro-section h2 {
		margin-bottom: 14px;
		font-size: var(--fs-h2);
	}

	.gbpro-section p {
		margin-bottom: 14px;
		font-size: var(--fs-body-lg);
	}

	.gbpro-section ul,
	.gbpro-section ol {
		margin-bottom: 18px !important;
	}
}

.gbpro-section--file-specs {
	position: relative;
	overflow: hidden;
	border-color: rgba(37, 211, 102, 0.34);
	background:
		linear-gradient(135deg, rgba(37, 211, 102, 0.14), transparent 36%),
		linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.01)),
		var(--gb-surface);

	&::after {
		position: absolute;
		top: 24px;
		right: 28px;
		width: 88px;
		height: 88px;
		border: 1px solid rgba(37, 211, 102, 0.22);
		border-radius: 24px;
		background: rgba(37, 211, 102, 0.06);
		box-shadow: 0 0 48px rgba(37, 211, 102, 0.18);
		content: '';
		transform: rotate(12deg);
	}

	h2 {
		position: relative;
		z-index: 1;
	}
}

.gbpro-section--pills {
	border-color: rgba(37, 211, 102, 0.22);
	background:
		linear-gradient(135deg, rgba(37, 211, 102, 0.08) 0%, transparent 48%),
		var(--gb-surface);

	.gbpro-pill-list {
		margin-top: 16px;
	}
}

.gbpro-section--steps {
	border-color: rgba(37, 211, 102, 0.24);
	background:
		linear-gradient(180deg, rgba(37, 211, 102, 0.06) 0%, transparent 28%),
		var(--gb-surface);

	> p {
		max-width: 72ch;
	}

	.gbpro-steps--timeline {
		margin-top: 20px;
	}
}

.gbpro-content--pc,
.gbpro-content--ios,
.gbpro-content--old {
	.gbpro-section {
		h2 {
			@media (min-width: 768px) {
				white-space: nowrap;
			}
		}
	}

	.gbpro-faq .gbpro-item-title,
	.gbpro-steps--timeline .gbpro-item-title {
		white-space: nowrap;
	}

	.gbpro-badges span {
		white-space: nowrap;
	}
}

.gbpro-file-specs {
	position: relative;
	z-index: 1;
	display: grid;
	grid-template-columns: minmax(220px, 1.05fr) repeat(2, minmax(180px, 1fr));
	gap: 14px;
	margin-top: 22px;
}

.gbpro-file-spec {
	display: grid;
	grid-template-columns: auto minmax(0, 1fr);
	align-items: center;
	gap: 6px 12px;
	min-height: 94px;
	padding: 18px;
	border: 1px solid var(--gb-line);
	border-radius: 12px;
	background: rgba(10, 24, 16, 0.72);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.gbpro-file-spec__icon {
	display: grid;
	place-items: center;
	grid-row: span 2;
	width: 42px;
	height: 42px;
	border: 1px solid var(--gb-line-strong);
	border-radius: 999px;
	background: var(--gb-green-soft);
	color: var(--gb-green-bright);
}

.gbpro-file-spec__label {
	color: var(--gb-muted);
	font-size: var(--fs-xs);
	font-weight: 800;
	letter-spacing: 0.08em;
	line-height: 1.2;
	text-transform: uppercase;
}

.gbpro-file-spec__value {
	overflow-wrap: anywhere;
	color: var(--gb-text);
	font-size: 1.05rem;
	font-weight: 800;
	line-height: 1.2;
}

.gbpro-file-spec--featured {
	grid-row: span 2;
	min-height: 202px;
	border-color: rgba(37, 211, 102, 0.48);
	background:
		linear-gradient(150deg, rgba(37, 211, 102, 0.22), rgba(10, 24, 16, 0.72) 52%),
		rgba(10, 24, 16, 0.9);
	box-shadow: 0 24px 46px rgba(0, 0, 0, 0.28), 0 0 36px rgba(37, 211, 102, 0.12);

	.gbpro-file-spec__icon {
		width: 52px;
		height: 52px;
		background: var(--gb-green-bright);
		color: var(--gb-btn-text);
	}

	.gbpro-file-spec__value {
		font-size: clamp(2.1rem, 4vw, 3.25rem);
		letter-spacing: 0;
	}
}

.gbpro-card-grid {
	display: grid;
	grid-template-columns: repeat(4, minmax(0, 1fr));
	gap: 14px;
	margin-top: 22px;
}

.gbpro-card__icon {
	display: inline-grid;
	place-items: center;
	width: 54px;
	height: 54px;
	margin-bottom: 14px;
	border-radius: 14px;
	background: var(--gb-green-soft);
	border: 1px solid var(--gb-line-strong);
	color: var(--gb-green-bright);
}

.gbpro-card-grid .gbpro-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
}

.gbpro-card__title {
	display: block;
	width: 100%;
	overflow: hidden;
	color: var(--gb-text);
	font-size: 0.98rem;
	font-weight: 700;
	line-height: 1.25;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.gbpro-card-grid .gbpro-card p {
	margin: 10px 0 0;
	color: var(--gb-muted);
	font-size: var(--fs-small);
	line-height: 1.55;
}

.gbpro-card__list {
	width: 100%;
	margin: 10px 0 0;
	padding-left: 1.1rem;
	text-align: left;
	color: var(--gb-muted);
	font-size: var(--fs-small);
	line-height: 1.55;

	li + li {
		margin-top: 6px;
	}
}

.gbpro-card__after {
	margin: 10px 0 0;
	color: var(--gb-muted);
	font-size: var(--fs-small);
	line-height: 1.55;
}

.gbpro-contact-form-wrap {
	margin: 8px 0 24px;
}

.gbpro-contact-form {
	display: grid;
	gap: 14px;
	max-width: 640px;
	padding: 22px;
	border: 1px solid var(--gb-line);
	border-radius: 16px;
	background: rgba(20, 20, 20, 0.92);
}

.gbpro-contact-form__field {
	display: grid;
	gap: 8px;

	span {
		color: var(--gb-text);
		font-size: var(--fs-small);
		font-weight: 700;
	}

	input,
	textarea {
		width: 100%;
		padding: 12px 14px;
		border: 1px solid var(--gb-line);
		border-radius: 10px;
		background: var(--gb-bg-deep);
		color: var(--gb-text);
		font: inherit;
		line-height: 1.5;

		&:focus {
			outline: none;
			border-color: var(--gb-line-strong);
			box-shadow: 0 0 0 2px var(--gb-green-soft);
		}
	}

	textarea {
		resize: vertical;
		min-height: 120px;
	}
}

.gbpro-contact-form__success {
	margin: 4px 0 0;
	color: var(--gb-green-bright);
	font-size: var(--fs-small);
	line-height: 1.6;
}

.gbpro-why-split {
	display: grid;
	grid-template-columns: minmax(0, 0.86fr) minmax(0, 1.14fr);
	gap: 40px;
	align-items: stretch;
	margin-top: 10px;
}

.gbpro-why-col {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-width: 0;
}

.gbpro-why-col .gbpro-item-title {
	margin-top: 0;
	color: var(--gb-text);
}

.gbpro-why-col--feedback {
	padding-left: 34px;
	border-left: 1px solid var(--gb-line);
}

.gbpro-feedback {
	margin-bottom: 22px;

	&:last-child {
		margin-bottom: 0;
	}
}

.gbpro-feedback__text {
	position: relative;
	margin: 0 0 6px;
	padding-left: 24px;
	color: var(--gb-muted);
	font-size: var(--fs-body);
	line-height: 1.6;

	&::after {
		display: block;
		clear: both;
		content: '';
	}
}

.gbpro-feedback__dot {
	position: absolute;
	left: 0;
	top: 7px;
	width: 12px;
	height: 12px;
	border-radius: 999px;
	background: var(--gb-green-bright);
	box-shadow: 0 0 10px var(--gb-green-glow);
}

.gbpro-feedback__author {
	float: right;
	margin: 3px 0 0 14px;
	color: var(--gb-soft-text);
	font-size: var(--fs-small);
	font-weight: 650;
	line-height: 1.45;
	white-space: nowrap;
}

.gbpro-feedback__code,
.gbpro-feedback__flag {
	font-size: var(--fs-xs);
	letter-spacing: 0.5px;
}

.gbpro-card,
.gbpro-step,
.gbpro-faq,
.gbpro-column {
	padding: 20px;
	border: 1px solid var(--gb-line);
	border-radius: 10px;
	background: var(--gb-surface-strong);
	min-width: 0;
}

.gbpro-faq .gbpro-item-title,
.gbpro-column .gbpro-item-title,
.gbpro-step .gbpro-item-title {
	margin-top: 0;
}

.gbpro-steps,
.gbpro-faqs,
.gbpro-quotes,
.gbpro-two {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 14px;
	margin: 20px 0;
}

.gbpro-steps--timeline {
	position: relative;
	display: block;
	margin: 28px 0 18px;
	padding-left: 54px;

	&::before {
		position: absolute;
		left: 15px;
		top: 8px;
		bottom: 8px;
		width: 2px;
		border-radius: 999px;
		background: linear-gradient(180deg, var(--gb-green-bright), rgba(37, 211, 102, 0.12));
		content: '';
	}
}

.gbpro-steps--timeline .gbpro-step {
	position: relative;
	margin: 0 0 18px;
	padding: 20px 22px;
	border-color: var(--gb-line-strong);
	background:
		linear-gradient(180deg, rgba(37, 211, 102, 0.06), rgba(37, 211, 102, 0.02)),
		var(--gb-surface-strong);

	&:last-child {
		margin-bottom: 0;
	}

	&::before {
		position: absolute;
		left: -22px;
		top: 34px;
		width: 22px;
		height: 2px;
		border-radius: 999px;
		background: var(--gb-green-bright);
		content: '';
	}
}

.gbpro-step__marker {
	position: absolute;
	left: -54px;
	top: 18px;
	display: grid;
	place-items: center;
	width: 32px;
	height: 32px;
	border: 2px solid rgba(37, 211, 102, 0.42);
	border-radius: 999px;
	background: var(--gb-green-bright);
	color: var(--gb-btn-text);
	font-size: 0.86rem;
	font-weight: 800;
	line-height: 1;
	box-shadow: 0 0 0 6px var(--gb-surface), 0 0 18px var(--gb-green-glow);
}

.gbpro-steps--timeline .gbpro-step .gbpro-item-title {
	margin-bottom: 8px;
	color: var(--gb-green-bright);
}

.gbpro-steps--timeline .gbpro-step p {
	margin-bottom: 0;
	font-size: var(--fs-body);
}

.gbpro-quotes blockquote {
	margin: 0;
	padding: 20px;
	border-left: 4px solid var(--gb-green);
	border-radius: 10px;
	background: var(--gb-surface-strong);
	color: var(--gb-muted);
	font-size: var(--fs-body);
	line-height: var(--lh-body);
}

.gbpro-section-image {
	margin: 22px 0 6px;
	text-align: center;
}

.gbpro-section-image img {
	max-width: min(340px, 82%);
	height: auto;
	border-radius: 18px;
	filter: drop-shadow(0 28px 56px rgba(37, 211, 102, 0.2));
}

.gbpro-section-split-media {
	display: grid;
	grid-template-columns: minmax(0, 1fr) minmax(300px, 0.82fr);
	gap: 28px;
	align-items: center;
	margin-top: 22px;
}

.gbpro-section-split-media__copy {
	min-width: 0;

	.gbpro-item-title {
		margin-top: 0;
	}

	ul {
		margin-bottom: 16px !important;
	}

	p:last-child {
		margin-bottom: 0;
	}
}

.gbpro-section-split-media__image {
	display: grid;
	place-items: center;
	min-width: 0;
}

.gbpro-section-split-media__image img {
	width: 100%;
	max-width: 390px;
	height: auto;
	border: 1px solid var(--gb-line);
	border-radius: 12px;
	box-shadow: 0 24px 48px rgba(0, 0, 0, 0.22), 0 0 36px rgba(37, 211, 102, 0.08);
}

.gbpro-pill-list {
	display: flex;
	flex-wrap: wrap;
	gap: 12px;
	margin: 18px 0 18px;
}

.gbpro-pill-list__item {
	display: inline-flex;
	align-items: center;
	gap: 9px;
	max-width: 100%;
	padding: 10px 15px;
	border: 1px solid var(--gb-line-strong);
	border-radius: 999px;
	background: var(--gb-green-soft);
	color: var(--gb-text);
	font-size: var(--fs-small);
	font-weight: 700;
	line-height: 1.35;
	white-space: nowrap;

	&::before {
		display: grid;
		place-items: center;
		flex: 0 0 18px;
		width: 18px;
		height: 18px;
		border-radius: 999px;
		background: var(--gb-green-bright);
		color: var(--gb-btn-text);
		content: '\2713';
		font-size: 0.68rem;
		font-weight: 900;
		line-height: 1;
	}
}

.gbpro-pill-list__item--con {
	border-color: rgba(255, 111, 97, 0.36);
	background: rgba(255, 111, 97, 0.12);

	&::before {
		background: #ff6f61;
		content: '\00d7';
		font-size: 0.86rem;
	}
}

.gbpro-pill-list--column {
	margin: 10px 0 0;
}

.gbpro-two--pills .gbpro-column {
	display: flex;
	flex-direction: column;
}

.gbpro-arrow-flow {
	display: grid;
	grid-template-columns: repeat(5, minmax(0, 1fr));
	gap: 22px;
	margin: 24px 0 22px;
}

.gbpro-arrow-flow__item {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	min-height: 132px;
	padding: 18px 16px;
	border: 1px solid var(--gb-line-strong);
	border-radius: 10px;
	background:
		linear-gradient(180deg, rgba(37, 211, 102, 0.07), rgba(37, 211, 102, 0.02)),
		var(--gb-surface-strong);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);

	&::after {
		position: absolute;
		top: 50%;
		right: -20px;
		width: 18px;
		height: 18px;
		border-top: 3px solid var(--gb-green-bright);
		border-right: 3px solid var(--gb-green-bright);
		content: '';
		transform: translateY(-50%) rotate(45deg);
		filter: drop-shadow(0 0 8px var(--gb-green-glow));
	}

	&:last-child::after {
		display: none;
	}
}

.gbpro-arrow-flow__number {
	display: grid;
	place-items: center;
	width: 34px;
	height: 34px;
	margin-bottom: 14px;
	border-radius: 999px;
	background: var(--gb-green-bright);
	color: var(--gb-btn-text);
	font-size: 0.9rem;
	font-weight: 800;
	line-height: 1;
	box-shadow: 0 0 16px var(--gb-green-glow);
}

.gbpro-arrow-flow__text {
	color: var(--gb-muted);
	font-size: var(--fs-small);
	font-weight: 650;
	line-height: 1.45;
}

.gbpro-section--compare {
	border-color: rgba(255, 255, 255, 0.06);
	background: linear-gradient(180deg, rgba(18, 18, 18, 0.96) 0%, rgba(10, 10, 10, 0.98) 100%);

	h2 {
		margin-bottom: 10px;
		font-size: clamp(1.5rem, 2.8vw, 2rem);
	}

	> p:first-of-type {
		margin-bottom: 24px;
		color: var(--gb-soft-text);
		font-size: var(--fs-body);
	}
}

.gbpro-section-title-accent {
	color: var(--gb-green-bright);
}

.gbpro-compare-wrap {
	overflow-x: auto;
	margin: 0 0 22px;
	border: 1px solid rgba(255, 255, 255, 0.08);
	border-radius: 16px;
	background: rgba(20, 20, 20, 0.92);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.gbpro-compare-summary {
	display: grid;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	gap: 20px;
	margin: 0 0 22px;

	ul {
		margin: 10px 0 0;
		padding-left: 1.2rem;
		color: var(--gb-muted);
	}

	li + li {
		margin-top: 8px;
	}
}

.gbpro-link-list {
	margin: 0 0 22px;
	padding-left: 1.2rem;
	color: var(--gb-muted);

	li + li {
		margin-top: 10px;
	}
}

.gbpro-inline-link {
	color: var(--gb-green-bright);
	font-weight: 700;
	text-decoration: underline;
	text-underline-offset: 0.18em;

	&:hover {
		color: var(--gb-green);
	}
}

.gbpro-compare-table {
	width: 100%;
	min-width: 640px;
	border-collapse: collapse;

	th,
	td {
		padding: 18px 22px;
		text-align: left;
		vertical-align: middle;
		border-bottom: 1px solid rgba(255, 255, 255, 0.07);
	}

	thead th {
		background: transparent;
		color: var(--gb-text);
		font-size: 1rem;
		font-weight: 700;
		letter-spacing: 0;
	}

	thead th:first-child {
		color: var(--gb-text);
	}

	thead th.is-gb {
		color: var(--gb-green-bright);
	}

	td.is-gb {
		background: rgba(37, 211, 102, 0.04);
	}

	tbody tr:last-child td {
		border-bottom: 0;
	}
}

.gbpro-compare-feature {
	color: var(--gb-text);
	font-size: var(--fs-body);
	font-weight: 700;
	line-height: 1.45;
}

.gbpro-compare-cell {
	display: inline-flex;
	align-items: flex-start;
	gap: 10px;
	max-width: 320px;
	color: var(--gb-muted);
	font-size: var(--fs-body);
	font-weight: 600;
	line-height: 1.45;
}

.gbpro-compare-cell--yes {
	color: var(--gb-text);
}

.gbpro-compare-icon {
	display: grid;
	place-items: center;
	flex: 0 0 auto;
	width: 22px;
	height: 22px;
	margin-top: 1px;
	border-radius: 999px;
	font-size: 0.72rem;
	font-weight: 900;
	line-height: 1;
}

.gbpro-compare-icon--yes {
	background: var(--gb-green-bright);
	color: var(--gb-btn-text);
	box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.14);
}

.gbpro-compare-icon--no,
.gbpro-compare-icon--block {
	background: var(--gb-danger);
	color: #fff;
}

.gbpro-compare-icon--warn {
	background: var(--gb-warning);
	color: #171204;
	clip-path: polygon(50% 10%, 92% 88%, 8% 88%);
	border-radius: 0;
}

.gbpro-compare-cell--warn {
	color: var(--gb-text);
}

.gbpro-cta-banner {
	display: flex;
	align-items: center;
	gap: 20px;
	margin: 24px 0 6px;
	padding: 24px 26px;
	border: 1px solid var(--gb-line-strong);
	border-radius: 14px;
	background: linear-gradient(135deg, rgba(37, 211, 102, 0.16) 0%, var(--gb-surface) 62%);
	box-shadow: var(--gb-shadow-panel);
}

.gbpro-cta-banner__icon {
	display: grid;
	place-items: center;
	flex: 0 0 auto;
	width: 64px;
	height: 64px;
	border-radius: 16px;
	background: linear-gradient(180deg, var(--gb-green-bright) 0%, var(--gb-green) 100%);
	color: var(--gb-btn-text);
}

.gbpro-cta-banner__copy {
	flex: 1 1 auto;
	min-width: 0;

	strong {
		display: block;
		margin-bottom: 6px;
		color: var(--gb-text);
		font-size: 1.02rem;
		font-weight: 700;
		line-height: 1.25;
	}

	span {
		color: var(--gb-muted);
		font-size: var(--fs-body);
		line-height: 1.55;
	}
}

.gbpro-cta-banner__action {
	display: flex;
	flex: 0 0 auto;
	flex-direction: column;
	align-items: center;
	gap: 8px;
}

.gbpro-cta-banner__meta {
	color: var(--gb-soft-text);
	font-size: var(--fs-xs);
	font-weight: 600;
}

.gbpro-table-wrap {
	overflow-x: auto;
	margin: 22px 0 18px;
	border: 1px solid rgba(37, 211, 102, 0.24);
	border-radius: 14px;
	background:
		linear-gradient(180deg, rgba(37, 211, 102, 0.1) 0%, rgba(18, 18, 18, 0.96) 16%, rgba(14, 14, 14, 0.98) 100%);
	box-shadow:
		0 16px 36px rgba(0, 0, 0, 0.34),
		inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

.gbpro-data-table {
	width: 100%;
	min-width: 560px;
	border-collapse: separate;
	border-spacing: 0;

	th,
	td {
		padding: 15px 18px;
		text-align: left;
		vertical-align: middle;
		border-bottom: 1px solid rgba(255, 255, 255, 0.06);
	}

	thead th {
		background: rgba(10, 24, 16, 0.98);
		font-size: var(--fs-body-lg);
		font-weight: 700;
		line-height: 1.35;
		white-space: nowrap;
	}

	thead th.is-feature {
		color: var(--gb-text);
		border-bottom: 1px solid rgba(37, 211, 102, 0.28);
	}

	thead th.is-mid {
		color: #ffd978;
		border-bottom: 1px solid rgba(245, 166, 35, 0.28);
	}

	thead th.is-accent,
	thead th.is-value {
		color: var(--gb-green-bright);
		border-bottom: 1px solid rgba(37, 211, 102, 0.28);
	}

	thead th:first-child {
		border-radius: 14px 0 0 0;
	}

	thead th:last-child {
		border-radius: 0 14px 0 0;
	}

	tbody td {
		color: var(--gb-muted);
		font-size: var(--fs-body);
		line-height: 1.5;
	}

	tbody td.is-feature {
		color: var(--gb-text);
		font-weight: 700;
		background: rgba(255, 255, 255, 0.025);
		border-left: 3px solid rgba(37, 211, 102, 0.5);
		padding-left: 15px;
	}

	tbody td.is-value {
		color: var(--gb-text);
		font-weight: 600;
		background: rgba(37, 211, 102, 0.08);
	}

	tbody td.is-mid {
		color: rgba(255, 255, 255, 0.88);
		font-weight: 600;
		background: rgba(245, 166, 35, 0.08);
	}

	tbody td.is-accent {
		color: var(--gb-text);
		font-weight: 600;
		background: rgba(37, 211, 102, 0.12);
	}

	tbody tr:nth-child(even) td.is-feature {
		background: rgba(255, 255, 255, 0.04);
	}

	tbody tr:nth-child(even) td.is-mid {
		background: rgba(245, 166, 35, 0.11);
	}

	tbody tr:nth-child(even) td.is-accent,
	tbody tr:nth-child(even) td.is-value {
		background: rgba(37, 211, 102, 0.15);
	}

	tbody tr:hover td {
		filter: brightness(1.06);
	}

	tbody tr:last-child td {
		border-bottom: 0;
	}

	tbody tr:last-child td:first-child {
		border-radius: 0 0 0 14px;
	}

	tbody tr:last-child td:last-child {
		border-radius: 0 0 14px 0;
	}
}

.gbpro-table-chip {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	padding: 0.32em 0.78em;
	border-radius: 999px;
	font-size: 0.9em;
	font-weight: 700;
	line-height: 1.2;
	white-space: nowrap;
}

.gbpro-table-chip--version {
	background: linear-gradient(180deg, var(--gb-green-bright) 0%, var(--gb-green) 100%);
	color: var(--gb-btn-text);
	box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.16);
}

.gbpro-table-chip--meta {
	border: 1px solid rgba(37, 211, 102, 0.3);
	background: rgba(37, 211, 102, 0.12);
	color: var(--gb-green-bright);
}

.gbpro-section--data-table {
	border-color: rgba(37, 211, 102, 0.22);
	background:
		linear-gradient(135deg, rgba(37, 211, 102, 0.07) 0%, transparent 42%),
		var(--gb-surface);

	> p {
		margin-bottom: 0;
		max-width: 72ch;
	}

	.gbpro-table-wrap {
		margin-top: 16px;
	}

	> p + .gbpro-table-wrap {
		margin-top: 14px;
	}
}

.gbpro-section--warning {
	border-color: rgba(245, 166, 35, 0.42);
	background:
		linear-gradient(135deg, rgba(245, 166, 35, 0.16) 0%, rgba(245, 166, 35, 0.06) 42%, var(--gb-surface) 100%);
	box-shadow:
		inset 4px 0 0 var(--gb-warning),
		0 12px 28px rgba(245, 166, 35, 0.08);

	h2 {
		display: flex;
		align-items: center;
		gap: 10px;
		color: #ffd978;

		&::before {
			display: grid;
			place-items: center;
			flex: 0 0 auto;
			width: 30px;
			height: 30px;
			border-radius: 999px;
			background: var(--gb-warning);
			color: #171204;
			content: '!';
			font-size: 1rem;
			font-weight: 900;
			line-height: 1;
			box-shadow: 0 0 0 4px rgba(245, 166, 35, 0.18);
		}
	}

	> p {
		color: var(--gb-text);
		font-size: var(--fs-body-lg);
		font-weight: 600;
		line-height: 1.7;
	}
}

.gbpro-warning-panel {
	display: flex;
	align-items: center;
	gap: 16px;
	margin-top: 20px;
	padding: 18px 20px;
	border: 1px solid rgba(245, 166, 35, 0.38);
	border-radius: 12px;
	background: rgba(245, 166, 35, 0.1);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.gbpro-warning-panel__alert {
	display: grid;
	place-items: center;
	flex: 0 0 auto;
	width: 42px;
	height: 42px;
	border-radius: 12px;
	background: var(--gb-warning);
	color: #171204;
	font-size: 1.35rem;
	font-weight: 900;
	line-height: 1;
	box-shadow: 0 10px 22px rgba(245, 166, 35, 0.22);
}

.gbpro-warning-panel__copy {
	min-width: 0;

	strong,
	span {
		display: block;
	}

	strong {
		margin-bottom: 6px;
		color: #ffe6a8;
		font-size: 1rem;
		font-weight: 800;
		line-height: 1.25;
	}

	span {
		color: rgba(255, 255, 255, 0.82);
		font-size: var(--fs-body);
		line-height: 1.6;
	}
}

.gbpro-warning-panel__badge {
	display: grid;
	place-items: center;
	flex: 0 0 auto;
	width: 72px;
	height: 72px;
	border: 1px solid rgba(245, 166, 35, 0.35);
	border-radius: 16px;
	background: rgba(245, 166, 35, 0.18);
	color: #ffd978;
	font-size: 1.1rem;
	font-weight: 800;
	letter-spacing: 0.08em;
}

.gbpro-section-cta {
	margin: 10px 0 20px;
}

.gbpro-section-visual {
	margin-top: 24px;
	border-radius: 12px;
	border: 1px solid var(--gb-line);
	background:
		radial-gradient(circle at 74% 20%, rgba(37, 211, 102, 0.08), transparent 32%),
		linear-gradient(135deg, var(--gb-surface) 0%, var(--gb-surface-strong) 100%);
	box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.gbpro-section-visual--download-safety {
	display: flex;
	align-items: center;
	gap: 18px;
	padding: 22px;
}

.gbpro-safety-mark {
	display: grid;
	place-items: center;
	width: 86px;
	height: 86px;
	flex: 0 0 auto;
	border-radius: 18px;
	background: var(--gb-warning);
	color: #171204;
	font-size: 1.3rem;
	font-weight: 700;
	box-shadow: 0 14px 28px rgba(255, 214, 84, 0.14);
}

.gbpro-safety-copy {
	min-width: 0;

	strong,
	span {
		display: block;
	}

	strong {
		margin-bottom: 6px;
		color: var(--gb-text);
		font-size: 1.02rem;
		font-weight: 700;
		line-height: 1.2;
	}

	span {
		color: var(--gb-muted);
		line-height: 1.55;
	}
}

@media (max-width: 760px) {
	.gbpro-warning-panel {
		flex-wrap: wrap;
	}

	.gbpro-warning-panel__badge {
		width: 56px;
		height: 56px;
		font-size: 0.95rem;
	}
}

@media (max-width: 1180px) {
	.gbpro-hero--home .gbpro-hero__inner {
		flex-direction: column;
		align-items: center;
		text-align: center;
		gap: 28px;
		max-width: 560px;
	}

	.gbpro-hero--home .gbpro-hero__copy {
		flex: 1 1 auto;
		width: 100%;
	}

	.gbpro-hero--home .gbpro-download-card {
		flex: 1 1 auto;
		width: 100%;
		max-width: 360px;
	}

	.gbpro-hero--home .gbpro-badges,
	.gbpro-hero--home .gbpro-actions {
		justify-content: center;
		flex-wrap: wrap;
	}
}

@media (max-width: 900px) {
	.gbpro-hero__inner {
		grid-template-columns: 1fr;
	}

	.gbpro-hero--home .gbpro-hero__inner {
		grid-template-columns: 1fr;
		gap: 34px;
	}

	.gbpro-hero--apk-download {
		padding: 32px 22px;
	}

	.gbpro-hero--apk-download .gbpro-hero__inner {
		grid-template-columns: 1fr;
		gap: 14px;
	}

	.gbpro-hero--apk-download .gbpro-hero__copy {
		min-height: auto;
	}

	.gbpro-hero-side {
		min-height: auto;
		padding: 16px 18px;
	}

	.gbpro-hero-side__steps {
		grid-template-columns: repeat(3, minmax(0, 1fr));
	}

	.gbpro-hero__art,
	.gbpro-download-card {
		justify-self: center;
	}

	.gbpro-card-grid {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.gbpro-file-specs {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}

	.gbpro-file-spec--featured {
		grid-column: 1 / -1;
		grid-row: auto;
		min-height: 150px;
	}

	.gbpro-section-split-media {
		grid-template-columns: 1fr;
	}

	.gbpro-arrow-flow {
		display: flex;
		gap: 24px;
		overflow-x: auto;
		padding: 0 4px 8px;
		scroll-snap-type: x proximity;
	}

	.gbpro-arrow-flow__item {
		flex: 0 0 210px;
		scroll-snap-align: start;
	}

	.gbpro-preview-window__body {
		grid-template-columns: 1fr;
	}
}

@media (max-width: 640px) {
	.gbpro-hero {
		padding: 38px 0 26px;
	}

	.gbpro-hero--home {
		padding-top: 28px;
	}

	.gbpro-hero--apk-download {
		padding: 28px 18px;
		border-radius: 8px;
	}

	.gbpro-hero--apk-download .gbpro-hero__copy {
		padding: 0;
		min-height: auto;
	}

	.gbpro-hero-side {
		padding: 18px;
	}

	.gbpro-hero-side__steps {
		grid-template-columns: 1fr;
		margin-top: 16px;
	}

	.gbpro-hero--apk-download .gbpro-hero-title-line--main {
		white-space: normal;
	}

	.gbpro-hero--apk-download .gbpro-badges span {
		width: 100%;
		justify-content: center;
	}

	.gbpro-hero-line {
		font-size: var(--fs-body);
	}

	.gbpro-eyebrow {
		margin-bottom: 22px;
	}

	.gbpro-actions,
	.gbpro-badges {
		gap: 9px;
	}

	.gbpro-badges {
		margin-top: 24px;
	}

	.gbpro-btn {
		width: 100%;
		padding: 12px 16px;
	}

	.gbpro-hero--home .gbpro-hero__art .gbpro-hero-icon {
		width: min(280px, 72vw);
	}

	.gbpro-download-card {
		width: 100%;
	}

	@media (max-width: 380px) {
		.gbpro-hero-title-line {
			white-space: normal;
		}
	}

	.gbpro-hero--download .gbpro-hero-line {
		white-space: normal;
	}

	.gbpro-content--pc,
	.gbpro-content--ios,
	.gbpro-content--old {
		.gbpro-section h2,
		.gbpro-faq .gbpro-item-title,
		.gbpro-steps--timeline .gbpro-item-title {
			white-space: normal;
		}
	}

	.gbpro-hero-preview,
	.gbpro-toc,
	.gbpro-content,
	.gbpro-content--legal {
		width: 100%;
	}

	.gbpro-section {
		padding: 24px 18px;
		border-radius: 10px;

		p {
			font-size: var(--fs-body);
		}
	}

	.gbpro-pill-list {
		flex-direction: column;
		align-items: stretch;
	}

	.gbpro-pill-list__item {
		width: 100%;
		border-radius: 14px;
		white-space: normal;
	}

	.gbpro-section--file-specs::after {
		top: 18px;
		right: 16px;
		width: 56px;
		height: 56px;
		border-radius: 16px;
	}

	.gbpro-file-specs {
		grid-template-columns: 1fr;
		gap: 12px;
	}

	.gbpro-file-spec,
	.gbpro-file-spec--featured {
		grid-column: auto;
		min-height: 86px;
		padding: 16px;
	}

	.gbpro-file-spec--featured .gbpro-file-spec__value {
		font-size: clamp(1.75rem, 10vw, 2.35rem);
	}

	.gbpro-card-grid,
	.gbpro-steps,
	.gbpro-faqs,
	.gbpro-quotes,
	.gbpro-two,
	.gbpro-why-split {
		grid-template-columns: 1fr;
	}

	.gbpro-steps--timeline {
		padding-left: 44px;

		&::before {
			left: 13px;
		}
	}

	.gbpro-steps--timeline .gbpro-step {
		padding: 18px;

		&::before {
			left: -18px;
			width: 18px;
		}
	}

	.gbpro-step__marker {
		left: -44px;
		width: 28px;
		height: 28px;
		font-size: 0.78rem;
	}

	.gbpro-why-col--feedback {
		padding-left: 0;
		padding-top: 20px;
		border-left: 0;
		border-top: 1px solid var(--gb-line);
	}

	.gbpro-section-visual--download-safety {
		align-items: flex-start;
	}

	.gbpro-cta-banner {
		flex-direction: column;
		text-align: center;
		padding: 22px 18px;
	}

	.gbpro-cta-banner__action {
		width: 100%;
	}

	.gbpro-cta-banner__action .gbpro-btn {
		width: 100%;
	}
}
</style>
